module.exports = __webpack_public_path__ + "static/img/iron.37ae9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tier-icons/iron.png
// module id = 372
// module chunks = 1